function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// @ts-nocheck
import React from 'react';
import * as R from 'unitx/ramda';
import { SchemaProcessor } from '@eva-design/processor';
// import Portal, { PortalHost } from '@components/Portal'
import { ModalPanel } from "../_/@ui-kitten/components/theme/modal/modalPanel.component";
import { StyleProvider } from "../_/@ui-kitten/components/theme/style/styleProvider.component";
export default class ApplicationProvider extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "state", {
      styles: this.props.styles
    });

    _defineProperty(this, "schemaProcessor", new SchemaProcessor());

    _defineProperty(this, "createStyles", (mapping, custom) => {
      const customizedMapping = R.mergeAll([{}, mapping, custom]);
      return this.schemaProcessor.process(customizedMapping);
    });

    if (!this.state.styles) {
      const {
        mapping,
        customMapping
      } = this.props;
      this.state.styles = this.createStyles(mapping, customMapping);
    }
  }

  render() {
    return /*#__PURE__*/React.createElement(StyleProvider, {
      theme: this.props.theme,
      styles: this.state.styles
    }, /*#__PURE__*/React.createElement(ModalPanel, null, this.props.children));
  }

}